'use client'

import type React from 'react'

import { cn } from '@mntn-dev/ui-utilities'
import { type TestIds, getTestProps } from '../../utils'

type CardsProps = Readonly<
  TestIds & {
    children: React.ReactNode
    className?: string
  }
>

const Cards = ({
  children,
  className,
  dataTestId,
  dataTrackingId,
}: CardsProps) => {
  return (
    <ul
      className={cn('w-full flex flex-wrap gap-8', className)}
      {...getTestProps({ dataTestId, dataTrackingId })}
    >
      {children}
    </ul>
  )
}

export { Cards, type CardsProps }
